// import { createSlice } from "@reduxjs/toolkit";
// import type { PayloadAction } from "@reduxjs/toolkit";
// import { ReactNode } from "react";

// export type UserState = {
//   data: {
//     userId: number | null;
//     accessToken: string | null;
//   };
//   title: string | ReactNode;
//   status: "idle" | "loading" | "succeeded" | "failed";
//   error: string | null;
// };

// const initialState: UserState = {
//   data: {
//     userId: parseInt(localStorage.getItem("userId") || "") || null,
//     accessToken: localStorage.getItem("accessToken") || "",
//   },
//   title: "",
//   status: "idle",
//   error: null,
// };

// const userSlice = createSlice({
//   name: "user",
//   initialState,
//   reducers: {
//     update: (
//       state,
//       action: PayloadAction<{
//         userId: number;
//         accessToken: string;
//       }>
//     ) => {

//       localStorage.setItem("accessToken", action.payload.accessToken);
//       localStorage.setItem("userId", action.payload.userId.toString());

//       state.data = {
//         userId: action.payload.userId,
//         accessToken: action.payload.accessToken,
//       };
//     },
//     deleteUserDetails: (state) => {
//       localStorage.removeItem("userId");
//       localStorage.removeItem("accessToken");
//       state.data = {
//         userId: null,
//         accessToken: null,
//       };
//     },
//     updateTitle: (
//       state,
//       action: PayloadAction<{ title: string | ReactNode }>
//     ) => {
//       state.title = action.payload.title;
//     },
//   },
// });

// // Action creators are generated for each case reducer function
// export const { update, deleteUserDetails, updateTitle } = userSlice.actions;

// export default userSlice.reducer;
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { ReactNode } from "react";

export type UserState = {
  data: {
    userId: number | null;
    accessToken: string | null;
  };
  title: string | ReactNode;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
};

const initialState: UserState = {
  data: {
    userId: null, // no userId will come now
    accessToken: localStorage.getItem("accessToken") || null,
  },
  title: "",
  status: "idle",
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    update: (
      state,
      action: PayloadAction<{
        accessToken: string;
      }>
    ) => {
      localStorage.setItem("accessToken", action.payload.accessToken);
      localStorage.setItem("userId", "");

      state.data = {
        userId: null,
        accessToken: action.payload.accessToken,
      };
    },

    deleteUserDetails: (state) => {
      localStorage.removeItem("userId");
      localStorage.removeItem("accessToken");

      state.data = {
        userId: null,
        accessToken: null,
      };
    },

    updateTitle: (
      state,
      action: PayloadAction<{ title: string | ReactNode }>
    ) => {
      state.title = action.payload.title;
    },
  },
});

export const { update, deleteUserDetails, updateTitle } = userSlice.actions;

export default userSlice.reducer;
